import { render, staticRenderFns } from "./service-synopsis.vue?vue&type=template&id=07e8537f"
import script from "./service-synopsis.vue?vue&type=script&lang=js"
export * from "./service-synopsis.vue?vue&type=script&lang=js"
import style0 from "./service-synopsis.vue?vue&type=style&index=0&id=07e8537f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports